<template>
  <el-card v-loading="isLoading">
    <el-row>
      <el-col>
        <filter-button :showfilter.sync="showFilter"></filter-button>
      </el-col>
    </el-row>
    <indicador-por-meta-periodo-filter class="chartstyle" :showfilter.sync="showFilter" v-show="showFilter"
                                       @filtroAplicado="filter"></indicador-por-meta-periodo-filter>
    <highcharts :options="options" v-show="!showFilter"></highcharts>
  </el-card>
</template>

<script>
  import IndicadorPorMetaPeriodoFilter from './IndicadorPorMetaPeriodoFilter'
  import {mapState} from 'vuex'
  import {trataErrors} from "@/domain/utils";
  import FilterButton from "@/components/shared/FilterButton";

  export default {
    name: "IndicadorPorMeta",
    components: {FilterButton, IndicadorPorMetaPeriodoFilter},
    data() {
      return {
        isLoading: false,
        showFilter: false,
        options: {}
      }
    },
    computed: {
      ...mapState(['anos', 'anoSelected', 'centroCustoList']),
    },
    methods: {
      async filter(event) {

        try {
          this.isLoading = true

          let eventNew = {
            ano: event.anoSelected,
            centro_custo_id: event.centroCustoSelected,
            indicador_id: event.indicadorSelected,
          }
          const {data} = await axios.post(`${process.env.API_URI_PATH}/dash/indicador/metaperiodo`, eventNew)
          this.options = {...data}

        } catch (error) {
          trataErrors(error)
        } finally {
          this.isLoading = false
        }
      }
    },
    async mounted() {
      const event = {
        anoSelected: this.anoSelected,
        centroCustoSelected: 2,
        indicadorSelected: 1,
      }
      await this.filter(event)
    }
  }
</script>

<style scoped>
  .chartstyle {
    height: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/features/Dashboard/Components/Home/Graficos/IndicadorPorMetaPeriodo.vue